import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { initialize } from 'redux-form'
import { bindActionCreators } from 'redux'

import { FuncaoForm } from '../../components'
import * as funcaoActionCreators from '../../redux/modules/funcao'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'

class FuncaoFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    history: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    fetchFuncao: PropTypes.func.isRequired,
    createFuncao: PropTypes.func.isRequired,
    updateFuncao: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func.isRequired,
    showErrorFlashMessage: PropTypes.func.isRequired,
    shouldHideFlashMessage: PropTypes.bool.isRequired,
    hideFlashMessage: PropTypes.func.isRequired,
    error: PropTypes.array,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    if (this.props.id) {
      const funcao = await this.props.fetchFuncao(this.props.id)
      this.props.initialize('FuncaoForm', {funcao})
    }
  }

  handleSubmitResource = async (fonteEnergia) => {
    if (this.props.id) {
      if (await this.props.updateFuncao(this.props.id, fonteEnergia)) {
        this.props.showSuccessfulFlashMessage('', 'update')
        this.props.history.push('/funcoes')
      } else {
        this.props.showErrorFlashMessage('', 'update', this.props.error)
      }
    } else {
      if (await this.props.createFuncao(fonteEnergia)) {
        this.props.showSuccessfulFlashMessage('', 'create')
        this.props.history.push('/funcoes')
      } else {
        this.props.showErrorFlashMessage('', 'create', this.props.error)
      }
    }
  }

  componentWillUnmount () {
    if (this.props.shouldHideFlashMessage)
      this.props.hideFlashMessage()
  }

  render () {
    return (
      <FuncaoForm
        onSubmit={(funcao) => this.handleSubmitResource(funcao)}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({funcao, status, flashMessage}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      funcao: funcao.get('id'),
      error: status.getIn(['funcao', 'error']),
      isLoading: status.getIn(['funcao', 'isLoading']),
      shouldHideFlashMessage: flashMessage.get('isError'),
    }
  }
  return {
    error: status.getIn(['funcao', 'error']),
    isLoading: status.getIn(['funcao', 'isLoading']),
    shouldHideFlashMessage: flashMessage.get('isError'),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...funcaoActionCreators,
    ...flashMessageAcionCreators,
    ...{initialize},
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FuncaoFormContainer)
